import MySQL from "../../../../contents/docs/cdp/sources/_snippets/source-mysql.mdx";
import * as React from 'react';
export default {
  MySQL,
  React
};